import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    parent: null,
    teacher: null
  },
  mutations: {
    loginAsParent(state, parent) {
      state.parent = parent
    },
    logoutAsParent(state) {
      state.parent = null
    },
    loginAsTeacher(state, teacher) {
      state.teacher = teacher
    },
    logoutAsTeacher(state) {
      state.teacher = null
    }
  },
  getters: {
    parent(state) {
      return state.parent
    },
    teacher(state) {
      return state.teacher
    },
    isParent(state) {
      return (state.parent) ? true : false
    },
    isTeacher(state) {
      return (state.teacher) ? true : false
    }
  }
})
